module.exports = __webpack_public_path__ + "media/doctor2.5be1c94645.png";